// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"archive-header_wrapper__SpdCF","content":"archive-header_content__8LhXt","form":"archive-header_form__R5q_f"};